/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import TranslationIds from '../../../commons/translationIds';
import Select from '../select';
import {
    DefaultDate,
    getDatesDataWithTranslation,
    getMonthsDataWithTranslation,
    getYearsDataWithTranslation,
    getDays,
    getCurrentYear,
} from './data';

import useWidgetTheme from '../../../commons/widgetTheme';
import { useStyles } from './styles';


function DateDropdown (props) {
    const {
        // touched,
        ecalClassName,
        translate = () => {},
        onChange = () => {},
        onClose =  () => {},
        label =  '',
        helperText =  '',
        error = false,
    } = props;

    const {
        widget,
        widgetTheme,
    } = useWidgetTheme();

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    const [month, setMonth] = useState(DefaultDate.MONTH);
    const [day, setDay] = useState(DefaultDate.DAY);
    const [year, setYear] = useState(DefaultDate.YEAR);

    const [months, setMonths] = useState([]);
    const [days, setDays] = useState([]);
    const [years, setYears] = useState([]);

    useEffect(() => {
        setDays(getDays(getCurrentYear(), month));
    }, []);

    function  getDaysParam () {
        const p = {
            year,
            month,
        };
        if (!p.year || p.year === '-') {
            p.year = getCurrentYear();
        }

        if (!p.month || p.month === '-') {
            p.month = null;
        }
        return p;
    }

    useEffect(() => {
        if (typeof translate === 'function') {
            if (month && month !== DefaultDate.MONTH) {
                setMonths(getMonthsDataWithTranslation(translate, true));
            } else {
                setMonths(getMonthsDataWithTranslation(translate));
            }
            
            const d = getDaysParam();
            if (day && day !== DefaultDate.DAY) {
                setDays(getDatesDataWithTranslation({
                    translate,
                    skipLabel: true,
                    ...d,
                }));
            } else {
                setDays(getDatesDataWithTranslation({
                    translate,
                    skipLabel: false,
                    ...d,
                }));
            }

            if (year && year !== DefaultDate.YEAR) {
                setYears(getYearsDataWithTranslation(translate, true));
            } else {
                setYears(getYearsDataWithTranslation(translate));
            }
        }
    }, [translate]);
 
    function updateDate (d, m, y) {
        const _m = m === DefaultDate.MONTH ? '00': m;
        const _y = y === DefaultDate.YEAR ? '1900' : y;
        const _d = d === DefaultDate.DAY ? '00': d;
        // const dateValue = `${_d}-${_m}-${_y}`;
        const dateValue = `${_y}-${_m}-${_d}`;
        if (typeof onChange === 'function') {
            onChange(dateValue);
        }
    }

    return (
    <Grid className={classNames([ecalClassName, classes.date])}>
        <Grid className={classNames(['ecal-input-label', classes.label])}>
            { label }
        </Grid>
        <Grid className={classes.dateFields}>

             <Select
                className={classes.day}
                placeHolder={translate(TranslationIds.COMPONENT_DAY)}
                helperText={''}
                labelHeading={''}
                value={day}
                dataProvider={days}
                onChange={(e, value) => {
                    console.log('change value: ', value);
                    if (value) {
                        setDay(value);
                        updateDate(value, month, year);
                    } else {
                        onClose();
                    }
                }}

                name={'year'} 
                error={error}
                />


            <Select
                className={classes.month}
                placeHolder={translate(TranslationIds.COMPONENT_MONTH)}
                helperText={''}
                labelHeading={''}
                value={month}
                dataProvider={months}
                onChange={(e, value) => {
                    if (value) {
                        setMonth(value);
                        updateDate(day, value, year);
                    } else {
                        onClose();
                    }
                    
                }}
                name={'month'}
                error={error}
                />

            <Select
                className={classes.year}
                placeHolder={translate(TranslationIds.COMPONENT_YEAR)}
                helperText={''}
                labelHeading={''}
                value={year}
                dataProvider={years}
                onChange={(e, value) => {
                    if (value) {
                        setYear(value);
                        updateDate(day, month, value);
                    } else {
                        onClose();
                    }
                }}
                name={'year'}
                error={error}
                />

                
        </Grid>
        {error && (
            <span className={classes.errorText}>
              {helperText}
            </span>
        )}
    </Grid>
    );
}

DateDropdown.propTypes = {
    translate: PropTypes.func,
    onChange: PropTypes.func,
    heleprText: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.bool,
    onClose: PropTypes.func,
};

export default DateDropdown;